export default __webpack_public_path__ + "static/casecard3-202f666b9980fde22800c9b03ff64861.png";